import { useEffect, useRef, useState } from "react";
const optionsDefault = ["Newest", "Oldest", "3 days"];
export default function DropdownProperties({
  onChange = (elm) => { },
  options = optionsDefault,
  defaultOption,
  addtionalParentClass = "",
  setItem,
  setIso,
  refItem,
  StateValue,
  disabledflag = false
}) {
  const selectRef = useRef();
  const [selected, setSelected] = useState("");
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        selectRef.current.classList.remove("open");
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const getOptionLabel = (elm) => {
    return typeof elm === "string" ? elm : elm?.PropertyGeneratedId || elm?.name || elm;
  };

  const getOptionValue = (elm) => {
    return typeof elm === "string" ? elm : elm?.PropertyId || elm?.isoCode || elm;
  };

  // When StateValue prop changes (e.g. when editing), auto-select matching option by isoCode/value/label
  useEffect(() => {
    
    if (StateValue != null && StateValue !== "") {
      const matched = options.find((elm) => {
        const val = String(getOptionValue(elm));
        const lab = String(getOptionLabel(elm));
        return val === String(StateValue) || lab === String(StateValue);
      });
      if (matched) {
        const value = getOptionValue(matched);
        const label = getOptionLabel(matched);
        setSelected(value);
        setItem && setItem(value);
        setIso && setIso(value);
        onChange && onChange(matched);
        return;
      }
    }

    if (defaultOption) {
      const matched = options.find(
        (elm) =>
          String(getOptionLabel(elm)) === String(defaultOption) ||
          String(getOptionValue(elm)) === String(defaultOption)
      );
      if (matched) {
        setSelected(getOptionValue(matched));
      }
    } else if (options && options.length && !selected) {
      // initialize to first option if nothing selected
      setSelected(getOptionValue(options[0]));
    }
  }, [StateValue, options, defaultOption]);

  const toggleDropdown = () => {
    if (disabledflag) return;
    if (selectRef.current) selectRef.current.classList.toggle("open");
  };

  const getSelectedLabel = () => {
    if (selected) {
      const matched = options.find((elm) => String(getOptionValue(elm)) === String(selected));
      if (matched) return getOptionLabel(matched);
    }
    return getOptionLabel(defaultOption ?? options[0]);
  };

  return (
    <>
      <div
        className={`nice-select ${addtionalParentClass} ${disabledflag ? "disabled" : ""}`}
        ref={(el) => {
          selectRef.current = el;
          if (refItem) refItem.current = el;
        }}
        aria-disabled={disabledflag}
      >
        <span
          onClick={() => toggleDropdown()}
          className="current"
          aria-disabled={disabledflag}
          style={{ pointerEvents: disabledflag ? "none" : "auto", opacity: disabledflag ? 0.6 : 1 }}
        >
          {getSelectedLabel()}
        </span>
        <ul className="list">
          {options.map((elm, i) => {
            const value = getOptionValue(elm);
            const label = getOptionLabel(elm);
            return (
              <li
                key={i}
                onClick={() => {
                  if (disabledflag) return;
                  setSelected(value);
                  setItem && setItem(value);
                  setIso && setIso(value);
                  onChange && onChange(elm);
                  toggleDropdown();
                }}
                className={`option ${String(selected) === String(value) ? "selected" : ""}  text text-1 ${disabledflag ? "disabled" : ""}`}
                aria-disabled={disabledflag}
              >
                {label}
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
}


